import * as React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import Footer from "../components/Footer";
import Reviews from "../components/Reviews";
import Subscribe from "../components/Subscribe";

import ReactGA from 'react-ga4';

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navActive: false,
      screenWidth: window.innerWidth,
      teamCollection: [
        {
          name: "Magnus Viking",
          text: "Owner & Lead Guide",
          thumbnail: { url: "/img/magnus_magnusson.jpg" },
        },
        {
          name: "Arni Odinsson",
          thumbnail: { url: "/img/arni_odinsson.jpg" },
          text: "Adventure Guide & Wilderness Expert",
        },
        {
          name: "Arnar Hjalmarsson",
          thumbnail: { url: "/img/arnar_hjalmarsson-2.jpg" },
          text: "Adventure Guide & Operations Manager",
        },
        {
          name: "Arni Hallgrimsson",
          thumbnail: { url: "/img/arni_hallgrimsson-2.jpeg" },
          text: "Adventure Guide & Head of Sales",
        },
        {
          name: "Inga Geirsdottir",
          thumbnail: { url: "/img/inga_geirsdottir.jpg" },
          text: "CFO and Mom",
        },
        {
          name: "Unnur Jonsdottir",
          thumbnail: { url: "/img/unnur_jonsdottir.jpg" },
          text: "Marketing",
        },
        {
          name: "Tristan Viking",
          thumbnail: { url: "/img/tristan_viking.jpg" },
          text: "Son of Magnus Viking",
        },
        {
          name: "Fenris the White Wolf",
          thumbnail: { url: "/img/fenris_the_white_wolf.jpg" },
          text: "King of Chaos, Trailblazer, Sheep Chaser, Center of Attention"
        },
        {
          name: "Matthias Arnason",
          thumbnail: { url: "/img/matthias_arnason.jpg" },
          text: "Superjeep Driver in Training, Son of Arni Hallgrimsson"
        },
        {
          name: "Jonas Valdimarsson",
          thumbnail: { url: "/img/jonas_valdimarsson.jpg" },
          text: "Adventure Guide",
        },
        {
          name: "Hilmar Oskarsson",
          thumbnail: { url: "/img/hilmar_oskarsson.jpg" },
          text: "Mountain Vehicle Driver",
        },
        {
          name: "Stefan Fridriksson",
          thumbnail: { url: "/img/stefan_fridriksson.jpg" },
          text: "Adventure Guide",
        },
        {
          name: "Johann Marelsson",
          thumbnail: { url: "/img/johann_marelsson.jpg" },
          text: "Mountain Vehicle Driver",
        },
        {
          name: "Dadi Hrannarsson",
          thumbnail: { url: "/img/dadi_hrannarsson.jpg" },
          text: "Adventure Guide & Electrician",
        },
        {
          name: "Johann Ivarsson",
          thumbnail: { url: "/img/johann_ivarsson.jpg" },
          text: "Adventure Guide",
        },
        {
          name: "Ingolfur Sigfusson",
          thumbnail: { url: "/img/ingolfur_sigfusson.jpg" },
          text: "Adventure Guide",
        },
        {
          name: "Thorbjorn Omarsson",
          thumbnail: { url: "/img/thorbjorn_omarsson.jpg" },
          text: "Adventure Guide",
        },
        {
          name: "Gunnar Magnusson",
          thumbnail: { url: "/img/gunnar_magnusson.jpg" },
          text: "Adventure Guide",
        },
      ],
    };

    this.hideNav = this.hideNav.bind(this);
    this.showNav = this.showNav.bind(this);
  }

  hideNav() {
    this.setState({ navActive: false });
  }

  showNav() {
    this.setState({ navActive: true });
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");

    window.addEventListener("resize", () => {
      this.setState({
        screenWidth: window.innerWidth,
      });
      if (this.state.navActive && window.innerWidth < 1440) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
        this.hideNav();
      }
    });

    document.title = "About us | Norse Adventures";

    ReactGA.initialize('G-CZG7EJ3P8E');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

  componentDidUpdate() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");
  }

  render() {
    return (
      <div className={"App flex flex-col items-center"}>
        <div className="bg-gray-900 text-white w-full p-2">
          The website is in development so you can expect some errors or display
          problems. Not all buttons and links work.
        </div>

        <header
          className={
            "flex flex-col items-center desktop:justify-center w-full group overflow-hidden" +
            (this.state.navActive & (this.state.screenWidth < 1440)
              ? " absolute"
              : " h-screen relative")
          }
        >
          <div
            className={
              "z-40 flex flex-row items-center justify-center w-full desktop:h-auto desktop:absolute desktop:top-0 desktop:left-0" +
              (this.state.navActive & (this.state.screenWidth < 1440)
                ? " h-screen flex-col"
                : "")
            }
          >
            <div
              className={
                "w-full h-full desktop:max-w-[1280px] flex bg-neutral-900 text-white desktop:m-16" +
                (this.state.navActive & (this.state.screenWidth < 1440)
                  ? " flex-col items-center justify-center"
                  : " flex-row" + (this.state.screenWidth < 1440 ? " bg-opacity-100" : " bg-opacity-90"))
              }
            >
              <a href="/">
                <div className="p-8 hover:bg-neutral-900">
                  <img
                    src="/runes.svg"
                    alt="Norse Logo"
                    className="invert w-48"
                  />
                </div>
              </a>
              <div
                id="navlinks"
                className={
                  "flex flex-col desktop:flex-row desktop:ml-auto text-xl font-black" +
                  (!this.state.navActive ? " ml-auto" : "")
                }
              >
                {this.state.navActive || this.state.screenWidth >= 1440 ? (
                  <>
                    <HashLink
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center"
                      to="/#adventures"
                    >
                      ADVENTURES
                    </HashLink>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 bg-neutral-900 h-full flex flex-col justify-center"
                      to="/about-us"
                    >
                      ABOUT US
                    </Link>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center items-center"
                      to="/blog"
                    >
                      BLOG
                    </Link>
                    <a
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center"
                      href="#contact-us"
                    >
                      CONTACT US
                    </a>
                  </>
                ) : (
                  <button onClick={this.showNav} className="text-3xl p-8">
                    ☰
                  </button>
                )}
              </div>
            </div>
          </div>

          {this.state.navActive && (
            <button
              onClick={this.hideNav}
              className="text-3xl p-8 absolute top-0 right-0 text-white z-50"
            >
              ☰
            </button>
          )}

          <img
            src="/img/11-big.webp"
            alt="A man standing on a cliff overlooking Hrafntinnusker"
            className="w-full h-full object-cover group-hover:brightness-110 bg-black"
          />
          <div className="absolute w-full h-full bg-black bg-opacity-20"></div>
          <div className="absolute h-full w-full flex flex-col items-start justify-end p-4 laptop:p-16 max-w-[1408px]">
            <div className="flex flex-col gap-4 mb-16">
              <span className="text-4xl tablet:text-5xl laptop:text-6xl laptop-lg:text-7xl desktop:text-8xl text-white font-black drop-shadow-md uppercase">
                The Team
              </span>
            </div>
          </div>
        </header>

        <main className="relative flex flex-col w-full max-w-[1408px] mt-16 px-4 laptop:px-16">
          <div className="w-full relative">
            <img src="img/DSC00634.jpg" className="object-cover aspect-[4/2] rounded-lg saturate-50 w-full bg-black" />
            <div className="z-10 absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black to-transparent"></div>
          </div>
          <div className="absolute z-20 top-0 left-0 w-full h-full flex flex-col items-center justify-center">
            <img src="img/norse-runes-logo.svg" className="w-96" />
            <ul className="text-white text-2xl flex flex-col items-start gap-2 mt-8">
              <li className="flex flex-row gap-2 items-center justify-center drop-shadow-md"><img src="img/check-icon.svg" className="w-8" /> Day tours</li>
              <li className="flex flex-row gap-2 items-center justify-center drop-shadow-md"><img src="img/check-icon.svg" className="w-8" /> Multi-day adventures</li>
              <li className="flex flex-row gap-2 items-center justify-center drop-shadow-md"><img src="img/check-icon.svg" className="w-8" /> Private tours</li>
              <li className="flex flex-row gap-2 items-center justify-center drop-shadow-md"><img src="img/check-icon.svg" className="w-8" /> Operated by local Icelanders</li>
              <li className="flex flex-row gap-2 items-center justify-center drop-shadow-md"><img src="img/check-icon.svg" className="w-8" /> Small family business</li>
            </ul>
          </div>
        </main>

        <section className="flex flex-col w-full max-w-[1408px] py-16 px-4 laptop:px-16">
          <ul className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-4 gap-8">
            {this.state.teamCollection.length > 0 ? (
              this.state.teamCollection.map((e) => (
                <li className="flex flex-col w-full aspect-[3/4] group ">
                  <img
                    src={e.thumbnail.url}
                    className="w-full h-full object-cover group-hover:brightness-110 rounded-lg overflow-hidden bg-black"
                  />
                  <div className="w-full p-4 pb-0 text-center text-4xl font-['norse']">{e.name}</div>
                  {e.text && (
                    <div className="w-full p-4 pt-1 text-center">{e.text}</div>
                  )}
                </li>
              ))
            ) : (
              <span className="text-4xl col-span-full text-center">
                No Team Members Found
              </span>
            )}
          </ul>
        </section>

        <Reviews />
        <Subscribe />
        <Footer />
      </div>
    );
  }
}
